export const pr2026 = [
    {
        "anio" : "Programa Anual de Evaluación",
        "descripcion" : "",
        "trimestres" : [
            {
                "trimestre" : "2026",
                "url" : "/Evgral"
            },
            /*{
                "trimestre" : "Segunda Sesión 2024",
                "url" : "/pdf/2Acocodi.pdf"
            },
            {
                "trimestre" : "Tercera Sesión 2024",
                "url" : "/pdf/3Acocodi.pdf"
            },
            {
                "trimestre" : "Cuarta Sesión 2024",
                "url" : "/pdf/4Acocodi.pdf"
            },
            {
                "trimestre" : "Primera Sesión 2025",
                "url" : "/pdf/1A25cocodi.pdf"
            },*/
            
        ]
    },
    {
        "anio" : "",
        "descripcion" : "",
        "trimestres" : [
            {
                "trimestre" : "Programa Anual de Evaluación",
                "url" : "/pdf/PAE2026.pdf"
            },
            {
                "trimestre" : "Evaluación",
                "url" : "/Ev2026"
            },
            {
                "trimestre" : "Monitoreo",
                "url" : "/Pr2026"
            },
            
            
        ]
    },
    {
        "anio" : "",
        "descripcion" : "Monitoreo",
        "trimestres" : [
            {
                "trimestre" : "Primer Trimestre 2026",
                "url" : "/pdf/monitoreo1.pdf"
            },
            {
                "trimestre" : "Segundo Trimestre 2026",
                "url" : "/pdf/monitoreo2.pdf"
            },
            {
                "trimestre" : "Tercer Trimestre 2026",
                "url" : "/Pr2026"
            },
            {
                "trimestre" : "Cuarto Trimestre 2026",
                "url" : "/Pr2026"
            }
            
            
        ]
    }
]